import { forwardRef, InputHTMLAttributes } from 'react';
import styles from './input.module.sass';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  error?: string;
  helperText?: string;
  size?: 'default' | 'compact';
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, size = 'default', ...rest }, ref) => {
    const inputClasses = `${styles.formInput} ${error ? styles.error : ''} ${size === 'compact' ? styles.compact : ''}`;

    return (
      <div className={styles.formGroup}>
        {label && <label className={styles.formLabel}>{label}</label>}
        <input ref={ref} className={inputClasses} {...rest} />
        {error && <span className={styles.formError}>{error}</span>}
        {helperText && !error && <span className={styles.formHint}>{helperText}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';
